

    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import moment from "moment";
    import Utils from "@/utilities/Utils";
    import { RegistrationAnswer } from "@/model/RegistrationAnswer";

    @Component({ })
    export default class PagePart extends Vue {

        mounted(): void {
            console.log("MOUNTED answer = ", this.registrationAnswer);
        }

        @Prop({ required: true })
        registrationAnswer!: RegistrationAnswer;

        @Prop({ required: true })
        pathwayId!: string;

        isPickerVisible: boolean = false;

        get rules(): Array<(() => string | boolean) | ((v: any) => string | true)> {
            const validator = (v: any) => !!v || "Please enter a response";
            return this.registrationAnswer.isMandatory && this.registrationAnswer.canShowForPathway(this.pathwayId) ? [ validator ] : [];
        }

        get pickerValue(): string {
            const x = this.toValueText(this.registrationAnswer.value);
            //console.log("pickerValue GET - value = ", x);
            return x;
        }

        get textFieldValue (): string {
            const x = this.toDisplayText(this.registrationAnswer.value);
            //console.log("textFieldValue GET ", x)
            return x;
        }

        onTextFieldBlur(): void {
            console.log("onTextFieldBlur (do we care???)");
            //this.dateText = this.parseDate(this.registrationAnswer.value);
        }

        onTextFieldInput(value: string|null): void {
            // it's readonly - but this will fire when we *clear* the field!
            if(!value) {
                this.registrationAnswer.value = "";
                console.log("onTextFieldInput - CLEAR");
            }
            else {
                console.log("onTextFieldInput (DON'T CARE!): ", value);
            }
        }

        onPickerInput(value: string|null): void {
            console.log("onPickerInput: ", value);
            this.registrationAnswer.value = this.toValueText(value);
            this.isPickerVisible = false;
        }

        selectToday(): void {
            this.registrationAnswer.value = this.toValueText(new Date());
            this.isPickerVisible = false;
        }

        // a couple of helper methods...

        toDisplayText(value: string|null): string {
            return Utils.dateText(value, "");
        }

        toValueText(value: string|null|Date): string {
            const m = moment(value);
            return m.isValid() ? m.format("YYYY-MM-DD") : "";
        }
    }
